export default "__VITE_ASSET__DDOkT0Nu__"